// extracted by mini-css-extract-plugin
export var createdDate = "_nt-1";
export var divider = "_nt-2";
export var headerDivider = "_nt-3";
export var messagesCard = "_nt-0";
export var messagesContainer = "_nt-7";
export var messagesContainerWrapper = "_nt-4";
export var pointerCapturingButtonBoxes = "_nt-a";
export var showLeftPanelButton = "_nt-9";
export var showMoreButton = "_nt-c";
export var showMoreButtonContainer = "_nt-b";
export var summaryTitle = "_nt-6";
export var systemMessageCardWrapper = "_nt-d";
export var topButtons = "_nt-8";
export var withPadding = "_nt-5";